import { Box, styled } from "@material-ui/core";
import {
  EPOCUS_BORDER,
  EPOCUS_PRIMARY,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_WHITE,
  rem,
} from "./epocus-palette";

export const ChipRow = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
});

const CHIP_BASE_STYLE: React.CSSProperties = {
  minHeight: 44,
  minWidth: 44,
  fontSize: rem(14),
  borderColor: EPOCUS_BORDER,
};

export const chipStyle = (selected: boolean): React.CSSProperties => ({
  ...CHIP_BASE_STYLE,
  fontWeight: selected ? 600 : 400,
  color: selected ? EPOCUS_WHITE : EPOCUS_TEXT_PRIMARY,
  backgroundColor: selected ? EPOCUS_PRIMARY : "transparent",
  borderColor: selected ? EPOCUS_PRIMARY : EPOCUS_BORDER,
});
